import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-retailer-dashboard',
  templateUrl: './retailer-dashboard.component.html',
  styleUrls: ['./retailer-dashboard.component.scss']
})
export class RetailerDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
